<template>
    <main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
 
        <!--=====================================
Hero
======================================-->
<section
    class="pt-32 lg:pt-[140px] xl:pt-[180px] pb-7 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
>
    <!-- Hero Content Wrapper -->
    <div
    class="flex flex-col gap-y-8 xl:flex-row justify-center md:justify-between items-center pl-10 reveal-me"
    >
    <!-- Text Content Container -->
    <div class="container max-sm:!-ml-[5%] lg:!ml-[10%] xl:!ml-[7%]">
        <!-- Agency Label & Tagline -->
        <div class="flex items-baseline gap-2 md:gap-2 lg:gap-3">
        <p class="font-poppins  tracking-[3px] text-xl md:text-xl lg:text-2xl">
            Websites
        </p>
        <span class="font-instrument italic text-xl md:text-xl lg:text-2xl">
            Supercharged.
        </span>
        </div>
        <!-- Responsive Headings -->
        <h1 class="mt-2 text-3xl sm:mt-6 sm:text-2xl md:text-3xl lg:hidden block">
            Free Design Consult – Limited Time
            Built in Los Angeles
       </h1>
        <h1 class="mt-6 text-3xl md:text-5xl lg:text-7xl hidden lg:block">
            Free Design Consult <br><span class="font-instrument italic">Limited Time</span>,
            Built <br>in Los Angeles
        </h1>
        <li
        class="block md:inline-block w-[80%] md:mr-auto md:ml-0 md:w-auto mt-5"
        >
        <router-link
            to="/contact"
            class="rv-button rv-button-primary block md:inline-block text-center"
        >
            <div class="rv-button-top contact-btn-sm">
            <span>Claim Offer</span>
            </div>
            <div class="rv-button-bottom contact-btn-sm">
            <span>Claim Offer</span>
            </div>
        </router-link>
        </li>
    </div>

    <!-- Hero Image -->
    <figure>
        <img src="@/assets/images/home-5/hero-img.jpg" alt="Hero Img" />
    </figure>
    </div>
</section>
    
<!--=====================================
Our Edge Section
======================================-->
<section
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
    >
      <div class="container">
        <div class="text-center mb-10 md:mb-20">
          <div class="rv-badge mb-3 md:mb-8 reveal-me">
            <span class="rv-badge-text">Our Edge</span>
          </div>
          <h2 class="text-appear">
            Why Brands Trust Us to Build Their Websites
          </h2>
        </div>
    
        <!-- Services Container -->
        <div
          class="max-w-[1170px] w-full mx-auto [&>*:not(:last-child)]:mb-6 reveal-me"
        >
            <div
                class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
                >
                <div
                    class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
                >
                    <div
                    class="absolute inset-0 opacity-0  bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                    :style="{ backgroundImage: `url(${laBased})` }"
                    ></div>
    
                    <div class="relative z-10 w-full md:w-1/2">
                    <h3
                        class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                    >
                    LA-Based
                    </h3>
                    </div>
    
                    <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                    <p
                        class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                    >
                    We’re local, accessible, and understand the fast-moving LA market.
                </p>
                    </div>
                </div>
            </div>
            <div
                class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
                >
                <div
                    class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
                >
                    <div
                    class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                    :style="{ backgroundImage: `url(${exceptionalQuality})` }"
    
                    ></div>
    
                    <div class="relative z-10 w-full md:w-1/2">
                    <h3
                        class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                    >
                    Exceptional Quality
                    </h3>
                    </div>
    
                    <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                    <p
                        class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                    >
                    Every detail—from code to design—is built to last and optimized for real-world performance.</p>
                    </div>
                </div>
            </div>
            <div
                class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
                >
                <div
                    class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
                >
                    <div
                    class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                    :style="{ backgroundImage: `url(${quickTurnaround})` }"
    
                    ></div>
    
                    <div class="relative z-10 w-full md:w-1/2">
                    <h3
                        class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                    >
                        Quick Turnaround
                    </h3>
                    </div>
    
                    <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                    <p
                        class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                    >
                        We move fast—without sacrificing quality or attention to detail.
                    </p>
                    </div>
                </div>
            </div>
            <div
                class="bg-white dark:bg-dark border border-secondary/10 dark:border-backgroundBody/10 transition-all duration-300"
                >
                <div
                    class="relative group z-10 cursor-pointer py-10 px-5 md:px-10 flex justify-between items-center flex-col md:flex-row"
                >
                    <div
                    class="absolute inset-0 opacity-0 bg-cover transition-opacity duration-700 in-expo group-hover:opacity-100"
                    :style="{ backgroundImage: `url(${provenResults})` }"
    
                    ></div>
    
                    <div class="relative z-10 w-full md:w-1/2">
                    <h3
                        class="font-medium text-[25px] md:text-4xl lg:text-[42px] xl:text-5xl leading-[25.2px] md:leading-[1.2] transition-colors duration-700 group-hover:text-white"
                    >
                        Proven Results
                    </h3>
                    </div>
    
                    <div class="relative z-10 w-full md:w-1/2 mt-4 md:mt-0">
                    <p
                        class="text-base md:text-xl md:leading-[1.4] md:tracking-[0.4px] transition-colors duration-700 group-hover:text-white"
                    >
                        Real stores, real sales, real success stories.
                    </p>
                    </div>
                </div>
            </div>
    
        </div>
      </div>
      <ul class="flex justify-center mt-[60px]">
        <li class="block md:inline-block w-[90%] mx-auto md:w-auto">
          <router-link
            to="/contact"
            class="rv-button rv-button-secondary block md:inline-block"
          >
            <div class="rv-button-top !text-center">
              <span>Claim Your Free Design</span>
            </div>
            <div class="rv-button-bottom !text-center">
              <span>Claim Your Free Design</span>
            </div>
          </router-link>
      </li>
    </ul>
</section>

<!--=====================================
Projects section
======================================-->
<section id="past-projects"
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
    >
      <div class="container">
        <div class="text-center">
          <div class="rv-badge mb-3 md:mb-8 reveal-me">
            <span class="rv-badge-text">Web Projects</span>
          </div>
          <h2 class="mx-auto mb-10 md:mb-20 text-appear">
            
            Designed and Built to Perform.
          </h2>
        </div>
        <div class="[&>*:not(:last-child)]:mb-4">
          <!-- Card -1 -->
          <div
            class="flex flex-col-reverse md:flex-row items-center border dark:border-dark md:gap-x-11 lg:gap-x-[70px] md:gap-y-10 reveal-me underline-hover-effect group"
          >
            <div class="pl-5 lg:pl-10 max-md:pr-5 max-lg:py-6 flex-1">
              <router-link to="/eoncycle">
                <div class="blog-title mb-6">
                  <h3
                    class="text[27px] md:text-4xl md:leading-[1.2] md:tracking-[-0.72px]"
                  >
                  Full-Stack Platform for AI-Powered Task Management
                </h3>
                </div>
              </router-link>
              <p class="border-t dark:border-dark pt-2 md:pt-5">
                From scattered to streamlined, we designed Pairboard’s core product—an intelligent task manager that helps teams stay focused, move faster, and automate the busywork.
            </p>
            </div>
            <figure
              class="overflow-hidden flex-1 w-full h-full max-md:p-3 max-lg:pr-4"
            >
              <router-link to="/eoncycle" class="block">
                <img
                src="@/assets/images/services/pairboard-1.png"
                alt="Econcycle product shot"
                  class="w-full h-full transition-all duration-500 group-hover:scale-125 group-hover:rotate-3"
                />
              </router-link>
            </figure>
          </div>
          <!-- Card -2 -->
          <div
            class="flex flex-col-reverse md:flex-row items-center border dark:border-dark md:gap-x-11 lg:gap-x-[70px] md:gap-y-10 reveal-me underline-hover-effect group"
          >
            <div class="pl-5 lg:pl-10 max-md:pr-5 max-lg:py-6 flex-1">
              <router-link to="/off-melrose">
                <div class="blog-title mb-6">
                  <h3
                    class="text[27px] md:text-4xl md:leading-[1.2] md:tracking-[-0.72px]"
                  >
                  Modern Shopify Design for a Women’s Fashion Label
                 </h3>
                </div>
            </router-link>
              <p class="border-t dark:border-dark pt-2 md:pt-5">
                From playful elegance to modern ease, we’re designing Off Melrose to deliver a shopping experience that reflects the vibe of LA streetwear meets boutique chic.
                      </p>
            </div>
            <figure
              class="overflow-hidden flex-1 w-full h-full max-md:p-3 max-lg:pr-4"
            >
              <router-link to="/off-melrose" class="block">
                <img
                  src="@/assets/images/services/off-melrose-1.png"
                  alt="Off Melrose Product Screenshot"
                  class="w-full h-full transition-all duration-500 group-hover:scale-125 group-hover:rotate-3"
                />
              </router-link>
            </figure>
          </div>
        </div>
      </div>
      <ul class="flex justify-center mt-[60px]">
        <li class="block md:inline-block w-[90%] mx-auto md:w-auto">
          <router-link
            to="/contact"
            class="rv-button rv-button-secondary block md:inline-block"
          >
            <div class="rv-button-top !text-center">
              <span>Let's Talk Details</span>
            </div>
            <div class="rv-button-bottom !text-center">
              <span>Let's Talk Details</span>
            </div>
          </router-link>
      </li>
    </ul>
    </section>

<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
>
  <div class="container">
    <div class="text-center">
        <h3 class="mx-auto mb-10 md:mb-20 text-appear">
            Some of our favorite languages and platforms.
        </h3>
    </div>
    <div
      class="max-w-4xl mx-auto grid max-md:grid-cols-2 md:grid-cols-4 reveal-me border-t border-x [&>*]:border-r max-md:[&>*:nth-child(2)]:border-r-0 max-md:[&>*:nth-child(6)]:border-r-0 [&>*:nth-child(4)]:border-r-0 [&>*:nth-child(8)]:border-r-0 [&>*]:border-b dark:[&>*]:border-dark dark:border-dark"
    >
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/php-svg-logo.svg"
          alt="PHP Logo"
          class="inline"
        />
        <span style="color: #777">PHP</span>
      </figure>

      <!-- Reverse Marquee -->
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/node-js-logo.svg"
          alt="Node JS Logo"
          class="inline"
        />
        <span style="color: #777">Node.js</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
        src="@/assets/images/marquee-img/python-logo.svg"
        alt="Python Logo"
        class="inline margin-auto"
        style="height: 75px; display: flex; margin: auto"
        />
        <span style="color: #777">Python</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/vue-logo.svg"
          alt="Vue JS Logo"
          class="inline"
        />
        <span style="color: #777">Vue.js</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/react-logo.svg"
          alt="React JS Logo"
          class="inline"
        />
        <span style="color: #777">React.js</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; margin: auto"
          src="@/assets/images/marquee-img/shopify-logo.svg"
          alt="Shopify Logo"
          class="flex"
        />
        <span style="color: #777">Shopify</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/wordpress-logo.svg"
          alt="Wordpress Logo"
          class="inline"
        />
        
        <span style="color: #777">Wordpress</span>
      </figure>
      <figure class="px-12 py-8 text-center">
        <img
          style="height: 75px; display: flex; margin: auto"
          src="@/assets/images/marquee-img/squarespace-logo.svg"
          alt="Squarespace Logo"
          class="inline"
        />
        <span style="color: #777">Squarespace</span>
      </figure>
    </div>
  </div>
  <ul class="flex justify-center mt-[60px]">
          <li class="block md:inline-block w-[90%] mx-auto md:w-auto">
            <router-link
              to="/contact"
              class="rv-button rv-button-secondary block md:inline-block"
            >
              <div class="rv-button-top !text-center">
                <span>Connect With Us</span>
              </div>
              <div class="rv-button-bottom !text-center">
                <span>Connect With Us</span>
              </div>
            </router-link>
          </li>
        </ul>
</section>

     <!--=====================================
       The Process Section
    ======================================-->
    
    <section
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
    >
      <div
        class="absolute max-lg:scale-y-[2.8] -z-30 scale-x-[2.2] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2"
      >
        <img src="@/assets/images/gradient-bg.png" alt="gradient-bg" />
      </div>
      <div class="container">
        <!-- Section Header -->
        <div
          class="flex flex-col md:flex-row gap-x-10 gap-y-4 justify-center lg:justify-between items-start mb-16 lg:mb-24"
        >
          <!-- Title Area -->
          <div class="flex-1 md:self-start">
            <h2 class="text-appear">
              <span class="font-instrument italic font-medium"> The Flow — </span>
              <br class="hidden md:block" />
              Our Process
            </h2>
          </div>
    
          <!-- Description -->
          <div class="flex-1 md:self-end">
            <p class="text-appear dark:text-colorText max-w-lg">
                This isn’t just a site. It’s your business online—custom-built to reflect your brand, solve real problems, and perform on every screen.
            </p>
          </div>
        </div>
    
        <!-- Services Grid -->
        <div
          class="grid grid-cols-12 justify-center items-center gap-[1px] reveal-me"
        >
          <!-- Discovery Service Card -->
          <div
            class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 backdrop-blur dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
          >
            <h4
              class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3"
            >
              Discovery
            </h4>
            <div class="rv-badge  md:mb-4">
                <span class="rv-badge-text">Free Consult</span>
            </div>
            <p
              class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
            >
                This is where we dive into your story, understand your brand, goals, and challenges. We align on what matters most and set the foundation for everything that follows.
            </p>
          </div>
    
          <!-- Strategy Service Card -->
          <div
            class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
          >
            <h4
              class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
            >
              Design
            </h4>
            <p
              class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
            >
             Design is where vision takes form. We turn ideas into clean, conversion-ready interfaces that feel on-brand, intuitive, and built to sell. Every layout, font, and micro-interaction is built to convert.
            </p>
          </div>
    
          <!-- Build Service Card -->
          <div
            class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-7 md:px-10 pt-7 md:pt-10 pb-4 md:pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
          >
            <h4
              class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
            >
              Develope
            </h4>
            <p
              class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
            >
                From Figma to fully functional. We develop every page, section, and feature with performance in mind—optimized for speed, SEO, and mobile-first usability.
            </p>
          </div>
    
          <!-- Design Service Card -->
          <div
            class="col-span-full max-sm:border-x max-sm:border-t max-sm:border-b max-sm:border-dark/5 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-10 pt-10 pb-16 bg-white/80 dark:bg-dark hover:bg-primary dark:hover:bg-primary group transition-all duration-300 ease-in-out min-h-[230px] sm:min-h-[400px]"
          >
            <h4
              class="md:text-[37px] dark:group-hover:text-secondary transition-colors duration-300 leading-[1.2] pb-3 md:mb-4"
            >
              Refine
            </h4>
            <p
              class="text-[17px] leading-[25.5px] text-[#000000b3] dark:text-dark-100 dark:group-hover:text-dark-200 transition-colors duration-300 font-medium italic"
            >
                Refinement is where good becomes great. After launch, we fine-tune speed, UX, and conversions—because top-performing stores are always evolving.        
            </p>
          </div>
        </div>
    
        <!-- CTA Button -->
        <ul class="flex justify-center mt-[60px]">
          <li class="block md:inline-block w-[90%] mx-auto md:w-auto">
            <router-link
              to="/contact"
              class="rv-button rv-button-secondary block md:inline-block"
            >
              <div class="rv-button-top !text-center">
                <span>Start Your Project</span>
              </div>
              <div class="rv-button-bottom !text-center">
                <span>Start Your Project</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    

    
    
     
     <!--=====================================
       FAQ Section
    ======================================-->
    <section
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative @@faqSpacing"
    >
      <div
        class="absolute scale-y-[3.5] sm:scale-y-[2.2] md:scale-y-[1.6] xl:scale-y-[1.4] scale-x-[1.7] left-1/2 top-1/2 max-md:-translate-y-[45%] md:-translate-y-1/2 -translate-x-1/2 -z-30"
      >
        <img src="@/assets/images/gradient-bg.png" alt="gradient-bg" />
      </div>
      <div class="container">
        <!-- FAQ Section Title -->
        <div class="text-center hidden">
          <div class="rv-badge mb-3 lg:mb-7 reveal-me">
            <span class="rv-badge-text">Faq</span>
          </div>
        </div>
        <h1 class="mb-10 md:mb-20 text-center lg:text-[84px] text-appear-2">
          Frequently Asked Questions
        </h1>
    
        <!-- FAQ Items Container -->
        <div
          class="max-w-[900px] w-full mx-auto [&>*:not(:last-child)]:mb-6 reveal-me"
        >
          <!-- FAQ Item 1 -->
          <div
            class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
          >
            <div
              class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
            >
              <h3
                class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-10"
              >
              How long does a custom website take to build?
            </h3>
              <div class="accordion-header-icon dark:border-dark"></div>
            </div>
            <p
              class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
            >
                It depends on scope. A simple marketing site can take 3–4 weeks, while a site with dashboards, user roles, or API work might take 6–8+. We’ll give you a timeline after scoping—and we stick to it.
            </p>
          </div>
    
          <!-- FAQ Item 2 -->
          <div
            class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
          >
            <div
              class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
            >
              <h3
                class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-10"
              >
              Can you migrate my existing site and data?
            </h3>
              <div class="accordion-header-icon dark:border-dark"></div>
            </div>
            <p
              class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
            >
             Yes, and we do it carefully. We back everything up, map old URLs for SEO, and test all data (like users, orders, or CMS content) in staging before go-live. You won’t lose content or search rankings.
            </p>
          </div>
    
          <!-- FAQ Item 3 -->
          <div
            class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
          >
            <div
              class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
            >
              <h3
                class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
              >
              What kind of support do you offer after launch?
            </h3>
              <div class="accordion-header-icon dark:border-dark"></div>
            </div>
            <p
              class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
            >
                Ongoing support includes feature requests, bug fixes, performance tuning, and security patches. You can do one-off updates or stay on a monthly retainer for peace of mind and faster turnarounds.
            </p>
          </div>
    
          <!-- FAQ Item 4 -->
          <div
            class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
          >
            <div
              class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
            >
              <h3
                class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
              >
              How involved do I need to be in the process?
            </h3>
              <div class="accordion-header-icon dark:border-dark"></div>
            </div>
            <p
              class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
            >
            You’ll approve the direction early, then we run with it. We’ll pull you in for feedback during key checkpoints, but you won’t be buried in technical stuff unless you want to be.
            </p>
          </div>
    
          <!-- FAQ Item 5 -->
          <div
            class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
          >
            <div
              class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
            >
              <h3
                class="text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
              >
              Can you integrate third-party tools and services?
            </h3>
              <div class="accordion-header-icon dark:border-dark"></div>
            </div>
            <p
              class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
            >
            Absolutely—CRMs, email tools, payment systems, AI APIs, you name it. If there’s documentation, we can hook it in cleanly and securely. No duct tape jobs.
            </p>
          </div>
        </div>
      </div>
    </section>
    
    
    <!--=====================================
       CTA Section
    ======================================-->
    <section
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
    >
      <div class="container">
        <div class="text-center">
          <div class="rv-badge reveal-me">
            <span class="rv-badge-text">Free Consultation</span>
          </div>
        </div>
        <!-- CTA Heading -->
        <h2
          class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
        >
          Got Questions?
          <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
            >We’ve Got Answers</span
          >
        </h2>
    
        <ul
        class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
      >
          <!-- Primary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
          >
          
          </li>
          <!-- Secondary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
          >
            <router-link
              to="/contact"
              class="rv-button rv-button-primary block md:inline-block"
            >
              <div class="rv-button-top contact-btn-lg">
                <span>Let's Connect</span>
              </div>
              <div class="rv-button-bottom contact-btn-lg">
                <span>Let's Connect</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    </main>
    
    <!--=====================================
       Footer Section
    ======================================-->
    <FooterComponent/>
    
    
    </template>
    <script>
    import FooterComponent from '@/components/FooterComponent.vue'
    import laBased from '@/assets/images/services/la-based.png' 
    import exceptionalQuality from '@/assets/images/services/abstract-wave.png' 
    import quickTurnaround from '@/assets/images/services/quick-turnaround.png' 
    import provenResults from '@/assets/images/services/proven-results.png' 
    import { Components } from '@/legacy/initLegacy'   // ← new import
    
    export default {
      name: 'BlingGram',
      components: {
        FooterComponent
      },
      mounted() {
        // wait until our template is rendered, then wire up the FAQ
        this.$nextTick(() => {
          Components.initFAQ()
        })
      },
      data() {
        return {
            laBased,exceptionalQuality,quickTurnaround,provenResults
        }
      }
    }
    </script>